import type { IValidationErrorDto } from "@/types/FormEngine/validation";
import { defineComponent } from "vue";
import {t, tRaw} from "@/services/Translation/t";
/**
 * @component
 */
export default defineComponent({
  name: "Button",
  props: {
    identifier: { type: String },
    mtdt: {
      type: Object as IField | any,
    },
  },
  data() {

    let normalizedXpath = "";
    let xmlNodeSelector = "";
    let xmlLastNodeSelector = "";

    let normalizedCodeXpath = "";
    let xmlCodeNodeSelector = "";
    let xmlCodeLastNodeSelector = "";
    if (this.mtdt.XpathEdoc && this.mtdt.XmlNodeSelector) {
      normalizedXpath = this.mtdt.XpathEdoc;
      xmlNodeSelector = this.mtdt.XmlNodeSelector;
      xmlLastNodeSelector = xmlNodeSelector.split(" > ").pop() as string;
      let foundElement = window.FormEngine.xmlService.xmlProcessingService.xmlToExport.querySelector(xmlNodeSelector + "Kod");
      if (foundElement) {
        normalizedCodeXpath = normalizedXpath + "Kod";
        xmlCodeNodeSelector = xmlNodeSelector + "Kod";
      }
    }
    if (this.mtdt.XpathCodelistCode && !normalizedCodeXpath && !xmlCodeNodeSelector) {
      normalizedCodeXpath = this.mtdt.XpathCodelistCode;
      xmlCodeNodeSelector = this.mtdt.XmlNodeCodeSelector;
      xmlCodeLastNodeSelector = xmlCodeNodeSelector.split(" > ").pop() as string;
    }
    return {
      htmlElement: null as any,
      normalizedXpath: normalizedXpath,
      xmlNodeSelector: xmlNodeSelector,
      defaultState: {
        isValid: true,
        hidden: this.mtdt.IsHidden,
        readOnly: this.mtdt.ReadOnlyFlag,
        hiddenLabel: !this.mtdt.HasHiddenLabel,
        customMask: this.mtdt.CustomMask,
        value: this.mtdt.DefaultValue,
        displayValue: "",
        required: this.mtdt.IsRequired,
        description: this.mtdt.Description,
        masked: this.mtdt.IsMasked,
        parent: this.mtdt.Parent,
        classes: "",
      },
      state: {
        isValid: true,
        errorMessages: new Array<IValidationErrorDto>(),
        hidden: this.mtdt.IsHidden === null ? false : this.mtdt.IsHidden,
        readOnly: this.mtdt.ReadOnlyFlag,
        hiddenLabel: !this.mtdt.HasHiddenLabel,
        customMask: this.mtdt.CustomMask,
        value: this.mtdt.DefaultValue ? this.mtdt.DefaultValue : "",
        displayValue: "",
        required: this.mtdt.IsRequired === null ? false : this.mtdt.IsRequired,
        description: this.mtdt.Description,
        masked: this.mtdt.IsMasked,
        parent: parent,
        classes: "",
        toExport: xmlNodeSelector ? true : false
      },
    };
  },
  created() {
    window.FormEngine.form.registerControl(this.identifier, this);
  },
  mounted(){
    if(this.identifier){
      this.htmlElement = document.getElementById(this.identifier);
    }
  },
  computed: {
    isValid(): boolean {
      return this.state.errorMessages.length === 0 ? true : false;
    },
    displayName(): string {
      return t("Name", this.identifier);
    },
    displayHint(): string {
      return t("Hint", this.identifier);
    },
    displayRequiredText() {
      if (tRaw("_utility")) {
        return " " + t("requiredText", "_utility");
      } else {
        return " " + "(nepovinný údaj)";
      }
    },
    hasErrors() {
      return !this.state.isValid;
    },
    controlDisabled() {
      return this.state.readOnly ? true : false;
    },
    hintId() {
      return this.identifier + "-hint";
    },
    errorId() {
      return this.identifier + "-error";
    },
    currentErrors() {
      return this.state.errorMessages;
    },
    controlId() {
      return this.identifier + "-control";
    },
  },
  methods: {
    setRequired(required:boolean){
      this.state.required = required;
    },
    subscribe(event: string, callback: Function) {
      window.FormEngine.events.subscribe(event, callback, this.identifier);
    },
    hide() {
      window.FormEngine.events.publish(window.FormEngine.events.list.HIDE, {
        validableId: this.identifier,
        control: this,
      },this.identifier);
      this.state.hidden = true;
      window.FormEngine.form.errorBag.removeErrors(this.identifier);
    },
    show() {
      window.FormEngine.events.publish(window.FormEngine.events.list.SHOW, {
        validableId: this.identifier,
        control: this,
      },this.identifier);
      this.state.hidden = false;
    },
    disable() {
      window.FormEngine.events.publish(window.FormEngine.events.list.DISABLE, {
        validableId: this.identifier,
        control: this,
      },this.identifier);
      this.state.readOnly = true;
    },
    enable() {
      window.FormEngine.events.publish(window.FormEngine.events.list.ENABLE, {
        validableId: this.identifier,
        control: this,
      },this.identifier);
      this.state.readOnly = false;
    },
    clickEvent(){
      console.log("click event");
    },
    resetErrors(){

    }
  }
});
